import React from 'react';
import { Flex, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { PasswordCard, PasswordScreen } from '../../password-policy';
import { LanguageSwitcher } from '../../language';
import { NS } from '../i18n';

const CONTROL_STYLE: React.CSSProperties = { width: '100%', height: 40 };

/**
 * Loading state for Reset password — while the route loads and while the page
 * validates the link from the email. The page's own screen (brand, welcome,
 * glass card) with placeholders where the title, the two password fields and
 * the button go, instead of a bare "Validating…" line.
 */
export function ResetPasswordSkeleton(): React.ReactElement {
  const { t } = useTranslation(NS);

  return (
    <>
      <LanguageSwitcher />
      <PasswordScreen>
        <PasswordCard>
          <Flex vertical gap={18} aria-busy="true" aria-label={t('reset.validatingAria')}>
            <Skeleton.Input active style={{ width: 220, maxWidth: '100%', height: 22 }} />
            <Skeleton.Input active block style={CONTROL_STYLE} />
            <Skeleton.Input active block style={CONTROL_STYLE} />
            <Skeleton.Button active block style={CONTROL_STYLE} />
          </Flex>
        </PasswordCard>
      </PasswordScreen>
    </>
  );
}
